
















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class TextMultiline extends Vue {
  @Prop() rules?: string;
  @Prop() validationField?: string;
  @Prop({ default: "" }) value?: string;
  @Prop({ default: "" }) placeholder?: string;
  @Prop({ default: "" }) dataCy?: string;
  @Prop({ default: false }) disabled?: boolean;

  onValueUpdated(value: unknown[] | undefined) {
    this.$emit("input", value);
  }
}
